// extracted by mini-css-extract-plugin
module.exports = {"styledDropdownMenu":"jAPrPNHG","prefixText":"MF8hjxa3","optionWrapper":"B63uaIg1","label":"eAWCs_8j","styledChip":"u0DXrF29","styledOptionWrapperDisabled":"SJ8vpSQU"};